import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="26" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M21.25 1L10 12.25 4.75 7 1 10.75l9 9 15-15L21.25 1z" stroke="#CCC" /></svg>;